class QuickMenu extends HTMLElement {
    constructor() {
        super();
        this.setup();
    }

    setup(){
        window.addEventListener("load", async () => {
            this.quickMenuBtn = this.querySelector('.quick-menu-btn');
            this.scrollTopBtn = this.querySelector('.js-scroll-top');
            this.prevBtn = this.querySelector('.prevBtn');
            this.nextBtn = this.querySelector('.nextBtn');


            this.quickMenuBtn.addEventListener('click', this.toggleMenu.bind(this));
            this.scrollTopBtn.addEventListener('click', this.scrollToTop.bind(this));

            this.prevBtn.disabled = true;
            this.prevBtn.addEventListener('click', this.handlePrevious.bind(this));
            this.nextBtn.addEventListener('click', this.handleNext.bind(this));
            this.carouselContainer = this.querySelector('.recently-viewed-carousel')

            this.productViewedToday = getProductsViewedToday();

            if(this.productViewedToday?.length === 0){
                // this.carouselContainer.style.height = "320px"
                return;
            }

            let response = await getProductsByIds(
                this.productViewedToday,
                `
                    title
                    handle
                    featuredImage { url }
                    priceRange{ 
                        maxVariantPrice { amount } 
                        minVariantPrice { amount } 
                    }
                `
            );

            if (response.result) {
                let products = response.data;
                this.loadSlider(products);
            }
        })
    }

    loadSlider(data){
        this.carouselViewport = this.querySelector('.js-carousel');

        if(data?.length === 0){
            return;
        }

        for (let index = 0; index < data.length; index++) {
            const product = data[index];
            let img_url = product?.featuredImage?.url
            let handle = product.handle;
            let div = document.createElement('div');
            div.className = "recently-viewed__carousel-cell";
            div.innerHTML =  `<a href="/products/${handle}" class="recently-viewed__thumbnail">
                    <img src="${img_url}" width="80px" alt="" srcset="">
            </a>`   
            this.carouselViewport.appendChild(div);        
        }
        this.totalCells = data.length || 0;
        this.cellsPerRow = 3;
        this.sliderLength = Math.ceil(this.totalCells / this.cellsPerRow) - 1;

        if(this.totalCells <= this.cellsPerRow){
            this.nextBtn.disabled = true
            let height = (this.totalCells * 80) + 65
            this.carouselContainer.style.height = `${height}px`;
        }else{
            this.carouselContainer.style.height = "320px"

        }

    }

    toggleMenu(event){
        if(this.getAttribute("open") === "true"){
            this.removeAttribute('open');
        }else{
            this.setAttribute('open', true)
        }
    }



    handlePrevious(event){
        let ele = this.querySelector(".js-carousel");
        this.nextBtn.removeAttribute('disabled');
        let index = ele.dataset.index;

        index = parseInt(index, 10)
        
        if(index >= 0){
            index -=1;
            let yAxis = index * -90;
            ele.style.transform = `translate3d(${yAxis}px, 10px, 0px)`
            ele.style.transitionDuration = `300ms`
            ele.dataset.index = index
            if(index === 0){
                this.prevBtn.disabled = true
            }
        }
    }

    handleNext(event){
        let ele = this.querySelector(".js-carousel");
        this.prevBtn.removeAttribute('disabled');

        let index = ele.dataset.index;
        index = parseInt(index, 10)
        
        if(index < this.sliderLength){
            index +=1;  
            let yAxis = index * -90;
            ele.style.transform = `translate3d(${yAxis}px, 10px, 0px)`
            ele.style.transitionDuration = `300ms`
            ele.dataset.index = index

            if(index === this.sliderLength){
                this.nextBtn.disabled = true;
            }
        }
    }

    scrollToTop(){
        window.scroll({
            top: 0, 
            left: 0, 
            behavior: 'smooth' 
        });
    }

    observer() {
        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (
                    mutation.type !== "attributes" ||
                    mutation.attributeName !== "open"
                ) {
                    return;
                }
                
            }
        });

        observer.observe(this, { attributes: true })
    }
}

customElements.define("quick-menu", QuickMenu);
